const rpc = "https://rpc.testnet.fantom.network/"
export default rpc;